import { gql } from '@apollo/client';


export const getProcesses = gql`
	query processes {
		processes { 
			id 
			name 
			seller {
				id
				name
			}
			workflowItems {
				id
      	name
      	phases {
      		id
        	name
				}
		}
		bundle { id name goods { name } }
		externalId { id externalId }
	}
} `

export const getProcess = gql`
  query process($id: Int!) {
    process(id: $id) { 
      id
      name
      email
      externalId {
        externalId
      }
      workflowItems {
        id
        name
				description
        phases {
          id
          name
          priority
					description
          steps {
            id
            name
		        priority
		        description
		        externalIds {
			        externalId
							externalIdType
		        }
          }
        }
      }
    }
  }
`;

export const allProcesses = gql `
  query processes {
    processes { 
			id name seller { name }
			workflowItems {
				id name processId
				phases {
					id name processWorkflowItemId priority
					steps {
						name description priority phase { id } externalIds { externalId externalIdType } stepType {id name}
					}
				}

			}
	}
}

`
